import { BatteryWarning, BarChart3 } from "lucide-react";
import { FormField, FormItem, FormControl } from "@/components/ui/form";
import { FormInput } from "@/components/forms/FormInput/FormInput";
import { cn } from "@/lib/utils";
import { observer } from "mobx-react-lite";
import { useAlarmWizardStore } from "./useAlarmWizardStore";

const TYPE_CARDS: { value: Dryp.AlarmType; icon: typeof BatteryWarning; title: string; description: string }[] = [
	{
		value: "device_health",
		icon: BatteryWarning,
		title: "Device",
		description: "Battery level, signal strength, and offline detection alerts",
	},
	{
		value: "measurement",
		icon: BarChart3,
		title: "Hydraulic",
		description: "Threshold-based alerts on sensor readings like pipe fill, water level, and flow rate",
	},
];

export const StepAlarmType = observer(() => {
	const state = useAlarmWizardStore();

	return (
		<div className="space-y-8">
			<FormInput name="name" label="Alarm name" placeholder="e.g. High Pipe Fill Alert" />

			<FormField
				control={state.form.control}
				name="alarmType"
				render={({ field }) => (
					<FormItem className="space-y-3">
						<div>
							<h3 className="text-base font-semibold">Alarm type</h3>
							<p className="text-sm text-muted-foreground mt-0.5">
								Choose the category that best fits your monitoring needs.
							</p>
						</div>
						<FormControl>
							<div className="grid grid-cols-2 gap-3">
								{TYPE_CARDS.map(card => {
									const isSelected = field.value === card.value;
									return (
										<button
											key={card.value}
											type="button"
											onClick={() => {
												if (field.value === card.value) return;
												// `form.reset(values)` updates BOTH the current value AND the
												// defaults. We pass everything except condition-step fields so
												// edit-mode defaults captured by loadForEdit can't snap those
												// three fields back. setValue / resetField alone weren't taking.
												const current = state.form.getValues();
												state.form.reset({
													...current,
													alarmType: card.value,
													parameterId: undefined as never,
													criticalThreshold: undefined as never,
													warningThreshold: null,
													operator: undefined as never,
												});
											}}
											className={cn(
												"flex flex-col gap-2 rounded-lg border-2 p-4 text-left transition-all hover:border-primary/50 cursor-pointer",
												isSelected
													? "border-primary bg-primary/5"
													: "border-border hover:bg-accent/50",
											)}
										>
											<div className="flex items-center gap-2.5">
												<div
													className={cn(
														"flex items-center justify-center size-7 rounded-md shrink-0",
														isSelected
															? "bg-primary/10 text-primary"
															: "bg-muted text-muted-foreground",
													)}
												>
													<card.icon className="size-4" />
												</div>
												<div className="font-semibold text-sm">{card.title}</div>
											</div>
											<div className="text-xs text-muted-foreground leading-relaxed">
												{card.description}
											</div>
										</button>
									);
								})}
							</div>
						</FormControl>
					</FormItem>
				)}
			/>
		</div>
	);
});
